import { resetAllApis } from "../../api/rtk/resetAllApis";
import { store } from "../../stateManagement/store";
import { navigateTo } from "../../widgets/navigationService/navigationServiceFunctions";
import { clearWebStorage, getItemWebStorage } from "../webStorageSaver";
import { logout } from "./authSlice";
import { indorsoftRuAPI, INDORID_BASE_URL } from "../../api/rtk/indorsoftRu/indorsoftRuApi";

/**
 * Выход из IndorID через sendBeacon
 * Использует sendBeacon для гарантированной отправки запроса даже при закрытии страницы
 */
function logoutIndorID(): void {
    const currentConfig = getItemWebStorage("currentConfig") ?? {};
    const isSupportEnabledInConfig = currentConfig?.support?.enabled ?? false;
    if (!isSupportEnabledInConfig) return;

    const url = `${INDORID_BASE_URL}auth/index.php?logout=yes`;

    // Пробуем sendBeacon (самый надежный способ)
    if (navigator.sendBeacon) {
        const sent = navigator.sendBeacon(url);
        if (sent) {
            return; // Успешно отправлено
        }
    }

    // Fallback для старых браузеров или если sendBeacon не сработал
    // Используем RTK Query mutation напрямую через store.dispatch
    store.dispatch(
        indorsoftRuAPI.endpoints.logoutIndorID.initiate(undefined, {
            // Fire-and-forget: не ждем результата, игнорируем ошибки
            subscribe: false,
        })
    ).catch(() => {
        // Игнорируем ошибки - выход из приложения должен произойти в любом случае
    });
}

export function logoutApp() {
    // Выход из IndorID через sendBeacon (не блокирует выход из приложения)
    logoutIndorID();

    clearWebStorage()
    store.dispatch(logout())
    resetAllApis()
    navigateTo('/')
}